import { createFileRoute } from "@tanstack/react-router";
import { browseDogsHomeRoute } from "@/app-clients/browse-dogs/routes/home-route";
import { FindHomePage } from "@/app-clients/browse-dogs/routes/find-home-page";

export const Route = createFileRoute("/_find/")({
    validateSearch: browseDogsHomeRoute.validateSearch,
    loaderDeps: browseDogsHomeRoute.loaderDeps,
    beforeLoad: browseDogsHomeRoute.beforeLoad,
    loader: browseDogsHomeRoute.loader,
    preload: false,
    head: browseDogsHomeRoute.head,
    component: FindHomePage,
});
